import { isEqual } from 'lodash'
import { MASS_OPERATION_HASH } from '@aytm/app/stats/page/comments/lib/constants'

const useTags = ({
  survey,
  tagsData,
  request = {},
  dispatch = () => true,
  setSurvey = () => true,
  onFetch,
  onTagsFetch,
  onUpdateSchema = () => true
}) => {
  const _onUpdateSchema = (data, updated = {}) => {
    let updatedTagsData = JSON.parse(JSON.stringify(tagsData || {}))

    const updatedTags = JSON.parse(JSON.stringify(survey.tags || {}))
    const updatedCodeBooks = JSON.parse(JSON.stringify(survey.codeBooks || []))

    if (Object.hasOwn(updated, 'tag')) {
      if (
        request.query?.some(item =>
          'sentiment' == item.type
            ? item.value == updated.tag.tag
            : 'tag' == item.type
              ? `${item.codebook}: ${item.value}` == updated.tag.tag
              : false
        )
      ) {
        onFetch()
      }

      let index
      let count

      updatedTagsData.tags ||= {}
      updatedTagsData.tags[updated.tag.type] ||= []

      window.survey.tags[updated.tag.type] ||= []
      window.survey.tagsStats ||= {}

      updatedTags[updated.tag.type] ||= []

      if (
        Object.hasOwn(data, 'codebook') &&
        (!Object.hasOwn(updated.tag, 'codebook') || null === updated.tag.codebook)
      ) {
        updated.tag.label = updated.tag.tag
        updated.tag.tag = `${data.codebook.title}: ${updated.tag.label}`

        const codebookIndex = updatedCodeBooks.findIndex(codebook => codebook.title == data.codebook.title)
        if (0 <= codebookIndex) {
          index = updatedCodeBooks[codebookIndex].tags.indexOf(updated.tag.label)
          if (0 > index) updatedCodeBooks[codebookIndex].tags.push(updated.tag.label)
        } else updatedCodeBooks.push(data.codebook)
      }

      const quantity = data.updatedTagsCount || 1

      index = updatedTagsData.tags[updated.tag.type].findIndex(tag => tag.tag == updated.tag.tag)
      if (0 <= index) {
        count = updatedTagsData.tags[updated.tag.type][index].amount || 0
        count = 'create' == updated.action ? count + quantity : Math.max(0, count - quantity)
        updatedTagsData.tags[updated.tag.type][index].amount = count
      } else {
        updatedTagsData.tags[updated.tag.type].push({
          tag: updated.tag.tag,
          amount: 'create' == updated.action ? quantity : 0
        })
      }

      if ('create' == updated.action) {
        index = window.survey.tags[updated.tag.type].indexOf(updated.tag.tag)
        0 > index && window.survey.tags[updated.tag.type].push(updated.tag.tag)

        index = updatedTags[updated.tag.type].indexOf(updated.tag.tag)
        0 > index && updatedTags[updated.tag.type].push(updated.tag.tag)
      }

      // subtract from current sentiment count
      if ('sentiment' == updated.tag.type) {
        // one sentiment
        if (updated.tag.currentValue && null !== updatedTagsData.tags[updated.tag.type]) {
          index = updatedTagsData.tags[updated.tag.type].findIndex(tag => tag.tag == updated.tag.currentValue)
          if (0 <= index) {
            const currentCount = updatedTagsData.tags[updated.tag.type][index].amount || 0
            updatedTagsData.tags[updated.tag.type][index].amount = Math.max(0, currentCount - quantity)
          }
          // mass sentiment
        } else if (Array.isArray(data.removedTagsCount) && data.removedTagsCount.length) {
          data.removedTagsCount.forEach(removedItem => {
            index = updatedTagsData.tags[removedItem.type].findIndex(tag => tag.tag == removedItem.tag)
            if (0 <= index) {
              updatedTagsData.tags[removedItem.type][index].amount = Math.max(
                0,
                updatedTagsData.tags[removedItem.type][index].amount - removedItem.count
              )
            }
          })
        }
      }

      for (const k of Object.keys(data.removedTagsByPath || {})) {
        for (const variable of [window.survey, updatedTagsData]) {
          variable.tagsStats[k] ||= {}

          data.removedTagsByPath[k].forEach(t => {
            variable.tagsStats[k][t.type] ||= []

            index = variable.tagsStats[k][t.type].findIndex(tag => tag.tag == t.tag)
            if (0 <= index) {
              count = Math.max(0, variable.tagsStats[k][t.type][index].amount - t.count)
              if (0 < count) {
                variable.tagsStats[k][t.type][index].amount = count
              } else variable.tagsStats[k][t.type].splice(index, 1)
            }
          })
        }
      }

      for (const k of Object.keys(data.updatedTagsByPath || {})) {
        for (const variable of [window.survey, updatedTagsData]) {
          variable.tagsStats[k] ||= {}
          variable.tagsStats[k][updated.tag.type] ||= []

          index = variable.tagsStats[k][updated.tag.type].findIndex(tag => tag.tag == updated.tag.tag)

          if ('create' == updated.action) {
            if (0 <= index) {
              variable.tagsStats[k][updated.tag.type][index].amount += data.updatedTagsByPath[k]
            } else {
              variable.tagsStats[k][updated.tag.type].push({
                tag: updated.tag.tag,
                amount: data.updatedTagsByPath[k]
              })
            }
          } else {
            if (0 <= index) {
              count = Math.max(0, variable.tagsStats[k][updated.tag.type][index].amount - data.updatedTagsByPath[k])
              if (0 < count) {
                variable.tagsStats[k][updated.tag.type][index].amount = count
              } else variable.tagsStats[k][updated.tag.type].splice(index, 1)
            }
          }
        }
      }

      if (updated.responseId) {
        dispatch({
          type: MASS_OPERATION_HASH[updated.action],
          data: { tag: updated.tag, path: updated.path, responseId: updated.responseId }
        })
      }
    } else {
      updatedTagsData = JSON.parse(JSON.stringify(data)) || {}
    }

    window.survey.codeBooks = updatedCodeBooks

    if (!isEqual(survey.codeBooks, updatedCodeBooks)) {
      setSurvey(Object.assign({}, survey, { tags: updatedTags, codeBooks: updatedCodeBooks }))
    } else if (!isEqual(survey.tags, updatedTags)) {
      setSurvey(Object.assign({}, survey, { tags: updatedTags }))
    }

    if (!isEqual(tagsData, updatedTagsData)) {
      dispatch({ type: 'SET_PARAM', request: { name: 'tagsData', value: updatedTagsData } })
    }

    if (onUpdateSchema && 'function' == typeof onUpdateSchema) {
      onUpdateSchema(updatedTagsData)
    }
  }

  const _onFetch = (data, updated = {}) => {
    let updatedTagsData = JSON.parse(JSON.stringify(tagsData || {}))

    const updatedTags = JSON.parse(JSON.stringify(survey.tags || {}))
    const updatedCodeBooks = JSON.parse(JSON.stringify(survey.codeBooks || []))

    let codebookIndex

    if (Object.hasOwn(updated, 'tags')) {
      updatedTagsData.tags ||= {}
      updatedTagsData.tags[updated.codebook.type] ||= []

      window.survey.tags[updated.codebook.type] ||= []
      window.survey.tagsStats ||= {}

      updatedTags[updated.codebook.type] ||= []

      codebookIndex = updatedCodeBooks.findIndex(codebook => codebook.title == updated.codebook.codebook)

      for (const tag of updated.tags) {
        updatedTagsData.tags[updated.codebook.type].push({ tag: tag.tag, amount: 0 })

        window.survey.tags[updated.codebook.type].push(tag.tag)

        updatedTags[updated.codebook.type].push(tag.tag)

        if (0 <= codebookIndex) {
          updatedCodeBooks[codebookIndex].tags.push(tag.label)
        }
      }
    } else if (Object.hasOwn(updated, 'tag')) {
      if (
        request.query?.some(item =>
          'sentiment' == item.type
            ? item.value == updated.tag.tag
            : 'tag' == item.type
              ? `${item.codebook}: ${item.value}` == updated.tag.tag
              : false
        )
      ) {
        onFetch()
      }

      let index
      let count

      updatedTagsData.tags ||= {}
      updatedTagsData.tags[updated.tag.type] ||= []

      window.survey.tags[updated.tag.type] ||= []
      window.survey.tagsStats ||= {}

      updatedTags[updated.tag.type] ||= []

      switch (updated.action) {
        case 'update': {
          const key =
            Object.hasOwn(updated.tag, 'destination') && null !== updated.tag.destination
              ? null !== updated.tag.destination.codebook
                ? `${updated.tag.destination.codebook}: ${updated.newValue}`
                : updated.newValue
              : null !== updated.tag.codebook
                ? `${updated.tag.codebook}: ${updated.newValue}`
                : updated.newValue

          index = updatedTagsData.tags[updated.tag.type].findIndex(tag => tag.tag == updated.tag.tag)
          if (0 <= index) {
            updatedTagsData.tags[updated.tag.type][index].tag = key
          }

          index = window.survey.tags[updated.tag.type].indexOf(updated.tag.tag)
          if (0 <= index) {
            window.survey.tags[updated.tag.type][index] = key
          }

          index = updatedTags[updated.tag.type].indexOf(updated.tag.tag)
          if (0 <= index) {
            updatedTags[updated.tag.type][index] = key
          }

          codebookIndex = updatedCodeBooks.findIndex(codebook => codebook.title == updated.tag.codebook)
          if (0 <= codebookIndex) {
            index = updatedCodeBooks[codebookIndex].tags.indexOf(updated.tag.label)
            if (0 <= index) {
              updatedCodeBooks[codebookIndex].tags[index] = updated.newValue
            }
          }

          for (const k of Object.keys(data.updatedTagsByPath || {})) {
            for (const variable of [window.survey, updatedTagsData]) {
              variable.tagsStats[k] ||= {}
              variable.tagsStats[k][updated.tag.type] ||= []

              index = variable.tagsStats[k][updated.tag.type].findIndex(tag => tag.tag == updated.tag.tag)
              if (0 <= index) {
                variable.tagsStats[k][updated.tag.type][index].tag = key
              }
            }
          }

          dispatch({
            type: MASS_OPERATION_HASH[updated.action],
            data: {
              tag: {
                tag: updated.tag.tag,
                type: updated.tag.type
              },
              newValue: key
            }
          })

          break
        }
        case 'create': {
          updatedTagsData.tags[updated.tag.type].push({ tag: updated.tag.tag, amount: 0 })

          window.survey.tags[updated.tag.type].push(updated.tag.tag)

          updatedTags[updated.tag.type].push(updated.tag.tag)

          codebookIndex = updatedCodeBooks.findIndex(codebook => codebook.title == updated.tag.codebook)
          if (0 <= codebookIndex) {
            updatedCodeBooks[codebookIndex].tags.push(updated.tag.label)
          }

          break
        }
        case 'clone': {
          const key =
            Object.hasOwn(updated.tag, 'destination') && null !== updated.tag.destination
              ? null !== updated.tag.destination.codebook
                ? `${updated.tag.destination.codebook}: ${updated.tag.label}`
                : updated.tag.label
              : null !== updated.tag.codebook
                ? `${updated.tag.codebook}: ${updated.tag.label}`
                : updated.tag.label

          index = updatedTagsData.tags[updated.tag.type].findIndex(tag => tag.tag == updated.tag.tag)
          if (0 <= index) {
            updatedTagsData.tags[updated.tag.destination.type] ||= []
            updatedTagsData.tags[updated.tag.destination.type].push({
              tag: key,
              amount: data.updatedTagsCount || 0
            })
          }

          window.survey.tags[updated.tag.destination.type] ||= []
          window.survey.tags[updated.tag.destination.type].push(key)

          updatedTags[updated.tag.destination.type] ||= []
          updatedTags[updated.tag.destination.type].push(key)

          codebookIndex = updatedCodeBooks.findIndex(codebook => codebook.title == updated.tag.destination.codebook)
          if (0 <= codebookIndex) {
            updatedCodeBooks[codebookIndex].tags.push(updated.tag.label)
          }

          for (const k of Object.keys(data.updatedTagsByPath || {})) {
            for (const variable of [window.survey, updatedTagsData]) {
              variable.tagsStats[k] ||= {}
              variable.tagsStats[k][updated.tag.type] ||= []
              variable.tagsStats[k][updated.tag.destination.type] ||= []

              index = variable.tagsStats[k][updated.tag.type].findIndex(tag => tag.tag == updated.tag.tag)
              if (0 <= index) {
                variable.tagsStats[k][updated.tag.destination.type].push({
                  tag: key,
                  amount: data.updatedTagsByPath[k] || 0
                })
              }
            }
          }

          dispatch({
            type: MASS_OPERATION_HASH[updated.action],
            data: {
              tag: {
                tag: updated.tag.tag,
                type: updated.tag.type
              },
              newValue: key
            }
          })

          break
        }
        case 'merge': {
          const key =
            Object.hasOwn(updated.tag, 'destination') && null !== updated.tag.destination
              ? null !== updated.tag.destination.codebook
                ? `${updated.tag.destination.codebook}: ${updated.newValue}`
                : updated.newValue
              : null !== updated.tag.codebook
                ? `${updated.tag.codebook}: ${updated.newValue}`
                : updated.newValue

          index = updatedTagsData.tags[updated.tag.type].findIndex(tag => tag.tag == updated.tag.tag)
          if (0 <= index) {
            updatedTagsData.tags[updated.tag.destination.type] ||= []

            if (Object.hasOwn(updated.tag, 'update')) {
              updatedTagsData.tags[updated.tag.type].splice(index, 1)

              index = window.survey.tags[updated.tag.type].indexOf(updated.tag.tag)
              if (0 <= index) {
                window.survey.tags[updated.tag.type].splice(index, 1)
              }

              index = updatedTags[updated.tag.type].indexOf(updated.tag.tag)
              if (0 <= index) {
                updatedTags[updated.tag.type].splice(index, 1)
              }

              codebookIndex = updatedCodeBooks.findIndex(codebook => codebook.title == updated.tag.codebook)
              if (0 <= codebookIndex) {
                index = updatedCodeBooks[codebookIndex].tags.indexOf(updated.tag.label)
                if (0 <= index) {
                  updatedCodeBooks[codebookIndex].tags.splice(index, 1)
                }
              }
            }

            // TODO
            index = updatedTagsData.tags[updated.tag.destination.type].findIndex(tag => tag.tag == key)
            if (0 <= index) {
              updatedTagsData.tags[updated.tag.destination.type][index].amount += data.updatedTagsCount
            } else {
              updatedTagsData.tags[updated.tag.destination.type].push({
                tag: key,
                amount: data.updatedTagsCount
              })
            }
          }

          for (const k of Object.keys(data.updatedTagsByPath || {})) {
            for (const variable of [window.survey, updatedTagsData]) {
              variable.tagsStats[k] ||= {}
              variable.tagsStats[k][updated.tag.type] ||= []
              variable.tagsStats[k][updated.tag.destination.type] ||= []

              index = variable.tagsStats[k][updated.tag.type].findIndex(tag => tag.tag == updated.tag.tag)
              if (0 <= index) {
                if (Object.hasOwn(updated.tag, 'update')) {
                  variable.tagsStats[k][updated.tag.type].splice(index, 1)
                }

                index = variable.tagsStats[k][updated.tag.destination.type].findIndex(tag => tag.tag == key)
                if (0 <= index) {
                  variable.tagsStats[k][updated.tag.destination.type][index].amount += data.updatedTagsByPath[k]
                } else {
                  variable.tagsStats[k][updated.tag.destination.type].push({
                    tag: key,
                    amount: data.updatedTagsByPath[k]
                  })
                }
              }
            }
          }

          dispatch({
            type: MASS_OPERATION_HASH[updated.action],
            data: {
              tag: {
                tag: updated.tag.tag,
                type: updated.tag.type,
                codebook: updated.tag.codebook,
                destination: {
                  tag: key,
                  type: updated.tag.destination.type,
                  codebook: updated.tag.destination.codebook
                }
              },
              update: Object.hasOwn(updated.tag, 'update')
            }
          })

          break
        }
        case 'delete': {
          index = updatedTagsData.tags[updated.tag.type].findIndex(tag => tag.tag == updated.tag.tag)

          // delete from everywhere
          if (updated.path) {
            if ('*' == updated.responseId) {
              // delete from all responses
              count = 0
            } else {
              // delete from current page
              count = (0 <= index && updatedTagsData.tags[updated.tag.type][index].amount) || 0
              count = Math.max(0, count - data.updatedTagsCount) || 0
            }

            index = updatedTagsData.tags[updated.tag.type].findIndex(tag => tag.tag == updated.tag.tag)
            if (0 <= index) {
              updatedTagsData.tags[updated.tag.type][index].amount = count
            }

            if ('sentiment' == updated.tag.type && data.updatedTagsCount) {
              index = updatedTagsData.tags[updated.tag.type].findIndex(tag => 'None' == tag.tag)
              if (0 > index) {
                updatedTagsData.tags[updated.tag.type].push({ tag: 'None', amount: data.updatedTagsCount || 0 })
              } else updatedTagsData.tags[updated.tag.type][index].amount += data.updatedTagsCount || 0
            }
          } else {
            updatedTagsData.tags[updated.tag.type].splice(index, 1)

            index = window.survey.tags[updated.tag.type].indexOf(updated.tag.tag)
            if (0 <= index) {
              window.survey.tags[updated.tag.type].splice(index, 1)
            }

            index = updatedTags[updated.tag.type].indexOf(updated.tag.tag)
            if (0 <= index) {
              updatedTags[updated.tag.type].splice(index, 1)
            }

            codebookIndex = updatedCodeBooks.findIndex(codebook => codebook.title == updated.tag.codebook)
            if (0 <= codebookIndex) {
              index = updatedCodeBooks[codebookIndex].tags.indexOf(updated.tag.label)
              if (0 <= index) {
                updatedCodeBooks[codebookIndex].tags.splice(index, 1)
              }
            }
          }

          for (const k of Object.keys(data.updatedTagsByPath || {})) {
            for (const variable of [window.survey, updatedTagsData]) {
              variable.tagsStats[k] ||= {}
              variable.tagsStats[k][updated.tag.type] ||= []

              index = variable.tagsStats[k][updated.tag.type].findIndex(tag => tag.tag == updated.tag.tag)
              // Only adjust the count / splice when the tag was actually found; otherwise a
              // stale `count` from a prior iteration writes to index -1 / splices the last
              // element (see _open-questions.md §OQ-19).
              if (0 <= index) {
                count = Math.max(0, variable.tagsStats[k][updated.tag.type][index].amount - data.updatedTagsByPath[k])

                if (0 < count) {
                  variable.tagsStats[k][updated.tag.type][index].amount = count
                } else variable.tagsStats[k][updated.tag.type].splice(index, 1)
              }

              if ('sentiment' == updated.tag.type && data.updatedTagsByPath[k]) {
                index = variable.tagsStats[k][updated.tag.type].findIndex(tag => 'None' == tag.tag)
                if (0 > index) {
                  variable.tagsStats[k][updated.tag.type].push({
                    tag: 'None',
                    amount: data.updatedTagsByPath[k] || 0
                  })
                } else variable.tagsStats[k][updated.tag.type][index].amount += data.updatedTagsByPath[k] || 0
              }
            }
          }

          dispatch({
            type: MASS_OPERATION_HASH[updated.action],
            data: {
              tag: {
                tag: updated.tag.tag,
                type: updated.tag.type
              }
            }
          })

          break
        }
      }
    } else {
      updatedTagsData = JSON.parse(JSON.stringify(data)) || {}
    }

    window.survey.codeBooks = updatedCodeBooks

    if (!isEqual(survey.codeBooks, updatedCodeBooks)) {
      setSurvey(Object.assign({}, survey, { tags: updatedTags, codeBooks: updatedCodeBooks }))
    } else if (!isEqual(survey.tags, updatedTags)) {
      setSurvey(Object.assign({}, survey, { tags: updatedTags }))
    }

    if (!isEqual(tagsData, updatedTagsData)) {
      dispatch({ type: 'SET_PARAM', request: { name: 'tagsData', value: updatedTagsData } })
    }

    if (onTagsFetch && 'function' == typeof onTagsFetch) {
      onTagsFetch(updatedTagsData, updated)
    }
  }

  return [_onUpdateSchema, _onFetch]
}

export default useTags
